import { css } from '@emotion/core';
import { getStyle } from './utils';

const textClass = css`
  color: ${getStyle('black')};
`;

export const detail = css`
  ${textClass};
  font-size: 14px;
  line-height: 20px;
`;

export const description = css`
  ${detail};
  font-weight: 200;
`;

export const error = css`
  ${detail};
  color: ${getStyle('pink')};
  font-size: 12px;
`;

export const title = css`
  ${textClass};
  font-size: 22px;
  line-height: 40px;
  font-weight: 500;
`;

export const titleSecondary = css`
  ${title};
  font-size: 18px;
  line-height: 22px;
`;
